// services/authService.js - Authentication API Client

const API_URL = process.env.REACT_APP_API_URL || 'https://jsa.arborascent.com';

class AuthService {
  /**
   * Redirect to OAuth login
   */
  login() {
    window.location.href = `${API_URL}/oauth/dashboard/connect`;
  }

  /**
   * Get current authenticated user
   */
  async me() {
    const response = await fetch(`${API_URL}/api/auth/me`, {
      credentials: 'include' // Include cookies
    });

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('Not authenticated');
      }
      throw new Error('Failed to get user info');
    }

    return response.json();
  }

  /**
   * Logout
   */
  async logout() {
    const response = await fetch(`${API_URL}/api/auth/logout`, {
      method: 'POST',
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to logout');
    }

    return response.json();
  }

  /**
   * Check if user is authenticated
   */
  async isAuthenticated() {
    try {
      await this.me();
      return true;
    } catch (error) {
      return false;
    }
  }
}

export default new AuthService();
